import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-label-vehicle',
  templateUrl: './label-vehicle.component.html',
  styleUrls: ['./label-vehicle.component.scss'],
})
export class LabelVehicleComponent {
  @Input() unitMeasurement?: string;
  @Input() value?: string;
  @Input() isBold?: boolean;
  @Input() description?: string;
  @Input() backgroundColor?: string;
}
